/**
 * Space Display Preferences
 *
 * Normalizes optional Space-level display settings.
 *
 * Primary responsibilities:
 * - Keep display toggles default-off
 * - Safely read JSON stored on Spaces
 *
 * Dependencies:
 * - types/spaces
 */

import type { SpaceDisplayPreferences } from "@/types/spaces"

export const defaultSpaceDisplayPreferences: Required<SpaceDisplayPreferences> = {
  showDayOverviewProgress: false,
  showItemsProgressOverview: false
}

export const normalizeSpaceDisplayPreferences = (
  value: unknown
): Required<SpaceDisplayPreferences> => {
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    return defaultSpaceDisplayPreferences
  }

  const preferences = value as SpaceDisplayPreferences

  return {
    showDayOverviewProgress: preferences.showDayOverviewProgress === true,
    showItemsProgressOverview: preferences.showItemsProgressOverview === true
  }
}
